const accountSelector = {
  label: "Seleccione una cuenta",
};

export default accountSelector;
